import { CSSProperties } from 'preact';

import cx from 'clsx';

import styles from './Skeleton.module.scss';

interface SkeletonProps {
	lines?: number;
	height?: number | string;
	width?: number | string;
	className?: string;
	id?: string;
	style?: CSSProperties;
}

const Skeleton = ({
	height = 16,
	className = '',
	lines = 1,
	width,
	...rest
}: SkeletonProps) => (
	<div className="d-flex flex-column gap4 width100" {...rest}>
		{new Array(lines).fill(1).map((_, index) => (
			<div
				key={index + _}
				className={cx(styles.skeleton, className)}
				style={{
					height,
					...(width ? { width } : {}),
				}}
			/>
		))}
	</div>
);

export default Skeleton;
